import React from "react";
import { VehiclesHero } from "@/components/VehiclesHero";
import { VehicleInventory } from "@/components/VehicleInventory";
import { CtaBand } from "@/components/CtaBand";

const Vehicles: React.FC = () => (
  <>
    <VehiclesHero />
    <VehicleInventory />
    <CtaBand
      eyebrow="Can't find what you're looking for?"
      title="Let's Find Your Perfect Car"
      desc="New stock arrives regularly. Get in touch with me directly for the latest availability, personalised recommendations, or to place a request."
    />
  </>
);

export default Vehicles;
